// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#2b6fef","menuHover":"#1e5ce5","subMenuBg":"#2b6fef","subMenuHover":"#1e5ce5","sideBarWidth":"180px"};